<template>
  <v-dialog
    v-model="dialog"
    width="800"
    persistent
    scrollable
  >
    <template #activator="{ on, attrs }">
      <!-- <v-btn :dark="darkbtn" :outlined="!darkbtn" small fab color="primary" v-bind="attrs" v-on="on" @click="init">
      <v-icon dark>mdi-plus</v-icon> 
    </v-btn> -->
      <span v-if="listButton">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="d-none d-sm-block"
          text
          @click="init"
        >
          {{ $t('deliveryCreate.createButtonLabel') }}
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </span>
      <span v-else>
        <v-btn
          plain
          small
          v-bind="attrs"
          v-on="on"
          @click="init"
        >
          <v-icon left>mdi-plus</v-icon>
          <span v-if="$vuetify.breakpoint.mobile">
            {{ $t('common.new') }}
          </span>
          <span v-else>
            {{ $t('deliveryCreate.createButtonLabel') }}
          </span>
        </v-btn>
      </span>
    </template>

    <v-card :loading="loading">
      <v-toolbar flat>
        <v-toolbar-title>
          {{ $t('deliveryCreate.title') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-container fluid v-if="!loading && model && !createResult">
          <v-row>
            <v-col>
              <v-alert v-if="!model.metadata.statuses.length" type="warning">
                {{ $t('deliveryCreate.noStatuses') }}
              </v-alert>
              <v-form v-model="valid">
                <v-autocomplete
                  v-model="model.data.statusId"
                  :rules="rules.required"
                  :items="model.metadata.statuses"
                  item-text="title"
                  item-value="id"
                  :label="$tc('common.status')"
                  auto-select-first
                  small-chips
                  outlined
                  dense
                />
                <v-autocomplete
                  v-model="model.data.deliveryType"
                  :rules="rules.required"
                  :items="model.metadata.deliveryTypes"
                  item-text="text"
                  item-value="value"
                  :label="$tc('common.type')"
                  return-object
                  auto-select-first
                  small-chips
                  outlined
                  dense
                  @change="getResponsibilities"
                />
                <v-autocomplete
                  v-model="model.data.location"
                  :rules="rules.required"
                  :items="model.metadata.locations"
                  item-text="text"
                  item-value="value"
                  :label="$tc('common.location')"
                  return-object
                  :search-input.sync="locationInput"
                  :disabled="!!taskRequest"
                  auto-select-first
                  small-chips
                  outlined
                  dense
                  @input="locationInput = null"
                />
                <v-autocomplete
                  v-model="model.data.departments"
                  :rules="rules.required"
                  :items="model.metadata.departments"
                  item-text="text"
                  item-value="value"
                  :label="$tc('common.department', 2)"
                  return-object
                  :search-input.sync="departmentInput"
                  :disabled="!!taskRequest"
                  auto-select-first
                  small-chips
                  deletable-chips
                  multiple
                  outlined
                  dense
                  @input="departmentInput = null"
                />
                <v-autocomplete
                  v-model="model.data.subjectAreas"
                  :rules="rules.required"
                  :items="model.metadata.subjectAreas"
                  item-text="text"
                  item-value="value"
                  :label="$tc('common.subjectArea', 2)"
                  return-object
                  :search-input.sync="subjectInput"
                  :disabled="!!taskRequest"
                  auto-select-first
                  small-chips
                  deletable-chips
                  multiple
                  outlined
                  dense
                  @input="subjectInput = null"
                />
                <v-autocomplete
                  v-for="r in responsibilities"
                  :key="r.id"
                  v-model="r.selectedPersonId"
                  :rules="r.required ? rules.required : null"
                  :items="r.selectableUsers"
                  item-text="fullName"
                  item-value="id"
                  eager
                  :label="r.responsibilityTitle"
                  outlined
                  dense
                  clearable
                />
                <v-autocomplete
                  v-model="model.data.followerPersons"
                  :items="model.metadata.persons"
                  item-text="text"
                  item-value="value"
                  :label="$tc('common.follower', 2)"
                  return-object
                  :search-input.sync="followerPersonsInput"
                  auto-select-first
                  small-chips
                  outlined
                  dense
                  multiple
                  @input="followerPersonsInput = null"
                />
                <v-text-field
                  v-model="model.data.title"
                  :rules="rules.required"
                  maxlength="250"
                  :label="$t('common.title')"
                  :disabled="!!taskRequest"
                  outlined
                  dense
                />
                <v-textarea
                  v-model="model.data.description"
                  :label="$t('common.description')"
                  outlined
                  dense
                />
                <v-menu
                  v-model="menuExpectedStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="model.data.expectedStart"
                      :rules="rules.required"
                      :label="$t('deliveryCreate.expectedStart')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      outlined
                      dense
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="model.data.expectedStart"
                    :max="model.data.expectedEnd"
                    @input="menuExpectedStart = false"
                  />
                </v-menu>
                <v-menu
                  v-model="menuExpectedEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="model.data.expectedEnd"
                      :rules="rules.required"
                      :label="$t('deliveryCreate.expectedEnd')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      outlined
                      dense
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="model.data.expectedEnd"
                    :min="model.data.expectedStart"
                    @input="menuExpectedEnd = false"
                  />
                </v-menu>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
        <div v-if="!!createResult">
          <div>
            {{ $t('deliveryCreate.createSuccess') }}:
          </div>
          <div>
            <router-link :to="`/delivery/${createResult.model.id}`">
              {{ createResult.model.code }}
            </router-link>
          </div>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="!createResult"
          outlined
          color="primary"
          @click="cancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          v-if="!createResult"
          color="secondary"
          :loading="saving"
          :disabled="!valid"
          @click="create"
        >
          {{ $t('deliveryCreate.create') }}
        </v-btn>
        <v-btn
          v-if="!!createResult"
          outlined
          color="primary"
          @click="close"
        >
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from '@/components/Loading';

export default {
  name: 'DeliveryCreate',
  components: {
    Loading
  },
  props: {
    listButton: {
      default: true,
      type: Boolean
    },
    taskRequest: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      model: null,
      createResult: null,
      //view only
      dialog: false,
      loading: true,
      loadingResponsibilities: false,
      saving: false,
      valid: false,
      menuExpectedStart: false,
      menuExpectedEnd: false,
      deliveryInput: null,
      locationInput: null,
      departmentInput: null,
      responsibilities: [],
      subjectInput: null,
      followerPersonsInput: null,
      rules: {
        required: [
          value => !!value || this.$t('common.requiredField')
        ]
      }
    };
  },
  methods: {
    async init() {
      this.getModel();
    },
    async getModel() {
      try {
        const response = await this.$api.get(`delivery/create`);

        this.model = response.data;

        // Handle DateTime values
        this.model.data.expectedStart = null;
        this.model.data.expectedEnd = null;

        // Set status to first if there are any
        if (this.model.metadata.statuses?.length) {
          const initialStatus = this.model.metadata.statuses.sort((a, b) => a.sortOrder - b.sortOrder)[0];
          this.model.data.statusId = initialStatus.id;
        }

        // Auto-select type if only one option
        if (this.model.metadata.deliveryTypes.length === 1) {
          this.model.data.deliveryType = this.model.metadata.deliveryTypes[0];
          this.getResponsibilities();
        }
        // Auto-select location if only one option
        if (this.model.metadata.locations.length === 1) {
          this.model.data.location = this.model.metadata.locations[0];
        }
        // Auto-select department if only one option
        if (this.model.metadata.departments.length === 1) {
          this.model.data.departments = [ this.model.metadata.departments[0] ];
        }
        // Auto-select subject areas if only one option
        if (this.model.metadata.subjectAreas.length === 1) {
          this.model.data.subjectAreas = [ this.model.metadata.subjectAreas[0] ];
        }

        // Auto-select responsibles if only one option
        this.model.data.responsibles?.forEach(r => {
          if (r.selectablePersons.length === 1) {
            r.selectedPersonId = r.selectablePersons[0].value;
          }
        });

        // set values from taskRequest if defined
        if (this.taskRequest) {
          this.model.data.taskRequestId = this.taskRequest.id
          this.model.data.location = { value: this.taskRequest.locationId }
          this.model.data.departments = this.taskRequest.departments
          this.model.data.subjectAreas = this.taskRequest.subjectAreas
          this.model.data.title = this.taskRequest.title
        }
      } catch (error) {
        this.dialog = false;
        this.$notifier.showError({ message: this.$t('errors.createDelivery') });
        this.Sentry.withScope((scope) => {
          scope.setLevel('critical');
          scope.setTransactionName('DeliveryCreate');
          this.Sentry.captureException(error);
        });
      } finally {
        this.createResult = null;
        this.loading = false;
      }
    },
    async getResponsibilities() {
      this.loadingResponsibilities = true;

      if (!this.model?.data?.deliveryType?.value) {
        this.responsibilities = [];
        return;
      }

      try {
        const { data } = await this.$api.get('delivery-type-responsibilities', {
          params: {
            deliveryTypeId: this.model.data.deliveryType.value
          }
        });

        for await (const item of data) {
          item.selectableUsers = await this.getSelectableUsers(item.responsibilityId);
        }

        this.responsibilities = data;
      } catch (error) {
        this.$notifier.showError({})
      } finally {
        this.loadingResponsibilities = false;
      }
    },
    async getSelectableUsers(responsibilityId) {
      try {
        const { data } = await this.$api.get('users', {
          params: {
            responsibilityId
          }
        });

        return data;
      } catch (error) {
        this.$notifier.showError({});
      }
    },
    async create() {
      this.saving = true;

      try {
        // Add Responsibles
        const model = {
          ...this.model.data,
          responsibles: this.responsibilities.map(x => {
            return {
              customerResponsibility_Id: x.responsibilityId,
              selectedPersonId: x.selectedPersonId
            }
          })
        }

        const { data } = await this.$api.post(`/Delivery/Create`, model);

        if (!data.success) throw new Error(data.errors[0] ?? 'An error occurred creating delivery')

        this.createResult = data;
        this.$notifier.showSuccess({ message: this.$t('deliveryCreate.successMessage') });
        this.$emit('saved');
        this.dialog = false;
      } catch (error) {
        this.Sentry.withScope((scope) => {
          scope.setLevel('critical');
          scope.setTransactionName('DeliveryCreate');
          this.Sentry.captureException(error);
        });
        this.$notifier.showError({ message: this.$t('errors.createDelivery') });
      } finally {
        this.saving = false;
      }
    },
    cancel() {
      this.dialog = false;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>